class Slider {
    slider: any;
    element: any;
    settings: any;
    breakpoint: number;
    reference: JQuery;
    constructor(element: any, settings: any, breakpoint: number) {
        this.element = element;
        this.settings = settings;
        this.breakpoint = breakpoint;
        this.reference = $('.slidethis--reference');
        this.init();
        this.resize();
    }
    public init(): any {

        if (window.innerWidth > this.breakpoint) {
            return false;
        }
        this.element.not('.slick-initialized').slick(this.settings);
    }

    public destroy(): any {
        this.element.slick('destroy');
    }

    public resize() {

        window.addEventListener('resize', () => {
            if (window.innerWidth < this.breakpoint) {
                this.init();
            }

            if (window.innerWidth >= this.breakpoint && this.element.hasClass('slick-initialized') === true) {
                this.destroy();
            }
        });
    }

}